module.exports = __webpack_public_path__ + "static/media/faq.aa3cffec.svg";